import React, { PropTypes } from 'react';
import { TextField } from 'material-ui';
import FlatButton from '../../../tc-ui/flat-button-with-loader.jsx';
import StepperActions from '../../generic-components/stepper-actions';

const TextContent = ({ onRequestClose, onTextFieldChange, contractId, saveSupplierInfoChanges, updateBuyerInfo, data, saving }) => {
  const termsCriteriaInfo = (title) => {
    switch (title) {
      case 'Add terms and conditions':
      case 'Edit terms and conditions':
        return {
          note: (<p>If your partner will need to agree to any terms and conditions, please enter them below. <br/><br/> For example, "We are not liable for any damages caused throughout the duration of travel."</p>),
        };
      case 'Add notes':
      case 'Edit notes':
        return {
          note: (<p>If you have any notes you'd like to include for your partner, please enter them below. <br/><br/> For example, "Please include the special cancellation policy we spoke about."</p>),
        };
      case 'Add market information':
      case 'Edit market information':
        return {
          note: (<div>
            <p>If you would like to describe the types of customers these rates apply to, please make your note below.</p>
            <p>For example, "Asia & Middle East excl. Japan."</p>
          </div>),
        };
      default:
        return (<div/>);
    }
  };

  return (
    <div style={{ width: '95%', margin: 'auto' }}>
      <div style={{ marginLeft: '20px', marginTop: '20px', marginBottom: '12px' }}>
        {termsCriteriaInfo(data.title).note}
      </div>
      <div
        style={{ overflowX: 'hidden', marginBottom: '20px' }}
      >
        {
          data.fieldName === 'marketInfo' || data.fieldName === 'corporateIdentificationNumber' ? (<TextField
            id="marketInfo"
            autoFocus
            defaultValue={data.value}
            errorText={data.value && data.value.length > 30 ? '30 character limit' : ''}
            onChange={({ target: { value } }) => onTextFieldChange({ key: data.fieldName, value, forTermsAndNotes: true })}
          />) : (<textarea
            style={{ overflowX: 'hidden', width: '100%' }}
            rows={8}
            placeholder="Enter here..."
            defaultValue={data.value}
            onChange={({ target: { value } }) => onTextFieldChange({ key: data.fieldName, value, forTermsAndNotes: true })}
          />)
        }
      </div>
      <StepperActions rightButtons={
        <div>
          <FlatButton
            label="Cancel"
            hoverColor="none"
            labelStyle={{ fontWeight: '600', marginRight: '15px' }}
            primary
            onTouchTap={onRequestClose}
          />
          <FlatButton
            label="Save"
            loader={saving}
            hoverColor="none"
            disabled={Boolean(data.fieldName === 'marketInfo' && data.value && data.value.length > 30)}
            labelStyle={{ fontWeight: '600' }}
            onTouchTap={data.forSupplier ? () => saveSupplierInfoChanges({ contractId, data, updateType: data.fieldName === 'marketInfo' ? 'UPDATE_MARKET_INFO' : 'UPDATE_SUPPLIER_INFO_TERMS_NOTES' })
              : () => updateBuyerInfo({ contractId, data })}
            secondary
          />
        </div>
        }
      />
    </div>
  );
};

TextContent.propTypes = {
  onRequestClose: PropTypes.func,
  contractId: PropTypes.string,
  productId: PropTypes.string,
  data: PropTypes.object,
  saveText: PropTypes.func,
  onTextFieldChange: PropTypes.func,
  createAmendment: PropTypes.func,
};

export default TextContent;



// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/add-edit-dialog-content/terms-criteria.jsx